module.exports = __webpack_public_path__ + "img/us-bg-bottom.b5282b3.png";